import { DOMINIO_BASE_SITES } from './api';
import type { ClientEntity } from '../types';

/**
 * ============================================================================
 * ONDE O SITE DE UM CLIENTE RESPONDE DE VERDADE
 * ============================================================================
 *
 * Sete telas montavam esse endereco por conta propria, todas do mesmo jeito
 * errado:
 *
 *     `${window.location.origin}/#/site/${client.slug}`
 *
 * Isso aponta para o PAINEL, nao para o site. E a rota que ele abre chama
 * `clientes.obterPorSlug`, que tem `acesso: 'operador'` no contrato: um
 * visitante anonimo leva 401. O campo aparecia rotulado como "Domínio / Link
 * Público" e era, na pratica, uma previa interna.
 *
 * O endereco real sai da API, em `sites.service.ts`:
 *
 *     `${slug}.${DOMINIO_BASE_SITES}`, ou o dominio proprio quando existe
 *
 * e quem responde nele e o Worker da borda, lendo o artefato do R2 — sem
 * passar pelo painel nem pela API.
 *
 * Este arquivo e a unica fonte desse endereco no painel. Se um dia o dominio
 * base mudar, muda aqui e na variavel de ambiente, e nada mais.
 */

/**
 * O endereco publico do site, na ordem de precedencia da propria API.
 *
 * 1. `urlPublica` — veio do servidor, ja resolvida. E a resposta certa quando
 *    existe, porque so o servidor sabe qual hostname esta marcado como
 *    principal.
 * 2. `customDomain` — dominio proprio do cliente, conhecido pela listagem.
 * 3. `slug.<dominio base>` — o subdominio padrao. Vale para a listagem, que
 *    nao carrega o site de cada cliente (seria uma consulta por linha).
 */
export function urlPublicaDoSite(client: Pick<ClientEntity, 'slug' | 'customDomain' | 'urlPublica'>): string {
  if (client.urlPublica) return client.urlPublica;
  if (client.customDomain) return `https://${client.customDomain}`;
  return `https://${client.slug}.${DOMINIO_BASE_SITES}`;
}

/** O mesmo endereco sem o esquema, para exibir. `https://` em fonte mono e ruido. */
export function hostPublicoDoSite(client: Pick<ClientEntity, 'slug' | 'customDomain' | 'urlPublica'>): string {
  return urlPublicaDoSite(client).replace(/^https?:\/\//, '').replace(/\/+$/, '');
}
